import { useTrainingsSettings } from './useTrainingsSettings'

export const useIsRelatorioEnabled = (companyId: string): boolean => {
  const { settings } = useTrainingsSettings(companyId)
  const setting = settings?.at(0)
  return !!setting?.relatorioEnabled
}
